import {ApplicationCategory, City, Department, FacilityCategory, MLevel, MRLevel, SpecificProductItem, Warehouse, SpecificProduct} from './CommonModels';
import * as Constants from './Constants';
import {ChecklistInstance, FlowType, PaymentInfo, ApplicationInfo, Organization, FacilitySpecificProductItem} from './ApplicationModel';
import { DocumentRef } from './DocumentRef';


export class RenewalDraftDetail {
  id: number;
  draftID: number;
  applicationNumber: number;
  applicationCategory: string;
  applicationCategoryID: string;
  agreedWithDeclaration: boolean;


  /**Application Properties */
  documents: DocumentDetail[] = [];
  paymentInfos: PaymentInfo[] = [];
  checkListItems: ChecklistInstance[];
  checkListInstances: ChecklistInstance[];
  checklistComplete: boolean;
  facility: FacilityDetail;
  productTypeID: number;
  /** */

  createdBy: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;

  constructor(draftObject){
    const draftApplication =  JSON.parse(draftObject.applicationJsonData);
    this.draftID  = draftObject.id;
    this.applicationNumber = draftObject.applicationNumber;
    this.applicationCategory = draftObject.applicationCategory;
    this.applicationCategoryID = draftObject.applicationCategoryID;
    this.id  = draftApplication.applicationID;
    this.facility = draftApplication.facility;
    this.checklistComplete = draftApplication.checklistComplete;
    this.checkListItems = draftApplication.checkListInstances;
    this.checkListInstances = draftApplication.checkListInstances;
    this.agreedWithDeclaration = draftApplication.agreedWithDeclaration;
    this.productTypeID = draftApplication.productTypeID;

    this.createdDate = draftObject.createdDate;
    this.createdBy = draftObject.createdBy;
    this.isActive = draftObject.isActive;
    this.modifiedDate = draftObject.modifiedDate;
    this.rowGuid = draftObject.rowGuid;

    if (draftApplication['documents'].length) {
      for (let rawDoc of draftApplication['documents']) {
        let doc = new DocumentDetail(rawDoc);
        this.documents.push(doc);
      }
    }
    if (draftApplication['paymentInfo']) {
      const paymentInf = draftApplication['paymentInfo'];
      let paymentInfo = new PaymentInfo(paymentInf);
      this.paymentInfos.push(paymentInfo);
    }
  }
}

export class ChangeDraftDetail {
  id: number;
  draftID: number;
  applicationNumber: number;
  applicationCategory: string;
  applicationCategoryID: string;
  changeSummary: string;


  /**Application Properties */
  documents: DocumentDetail[] = [];
  paymentInfos: PaymentInfo[] = [];
  checkListItems: ChecklistInstance[];
  checkListInstances: ChecklistInstance[];
  checklistComplete: boolean;
  facility: FacilityDetail;
  newApplicationChangeTypes: NewApplicationChangeType[] = [];
  /** */

  createdBy: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;

  productTypeID: number;
  location: Location;
  specificProductIDs: number[];
  specificProductItemIDs: number[];
  mrLevelID: number;
  mLevelID: number;
  professionals: Professionals[];
  facilitySpecificProductItems: FacilitySpecificProductItem[];

  constructor(draftObject){
    const draftApplication =  JSON.parse(draftObject.applicationJsonData);
    this.draftID  = draftObject.id;
    this.applicationNumber = draftObject.applicationNumber;
    this.applicationCategory = draftObject.applicationCategory;
    this.applicationCategoryID = draftObject.applicationCategoryID;
    this.id  = draftApplication.applicationID;
    this.facility = draftApplication.facility;
    this.checklistComplete = draftApplication.checklistComplete;
    this.checkListItems = draftApplication.checkListInstances;
    this.checkListInstances = draftApplication.checkListInstances;
    this.changeSummary = draftApplication.changeSummary
    this.location = draftApplication.location;
    this.specificProductIDs = draftApplication.specificProductIDs;
    this.specificProductItemIDs = draftApplication.specificProductItemIDs;
    this.mrLevelID = draftApplication.mrLevelID;
    this.mLevelID = draftApplication.mLevelID;
    this.professionals = draftApplication.professionals;
    this.productTypeID = draftApplication.productTypeID;
    this.createdDate = draftObject.createdDate;
    this.createdBy = draftObject.createdBy;
    this.isActive = draftObject.isActive;
    this.modifiedDate = draftObject.modifiedDate;
    this.rowGuid = draftObject.rowGuid;
    this.facilitySpecificProductItems = draftApplication.facilitySpecificProductItems || [];

    if(draftApplication['newApplicationChangeTypes'].length){
      for(let changeType of draftApplication['newApplicationChangeTypes']){
        let changeTypeObj = new NewApplicationChangeType(changeType);
        this.newApplicationChangeTypes.push(changeTypeObj)

      }
    }
    if (draftApplication['documents'].length) {
      for (let rawDoc of draftApplication['documents']) {
        let doc = new DocumentDetail(rawDoc);
        this.documents.push(doc);
      }
    }
    if (draftApplication['paymentInfos']) {
      for (let paymentInf of draftApplication['paymentInfos']) {
        let paymentInfo = new PaymentInfo(paymentInf);
        this.paymentInfos.push(paymentInfo);
      }
    }
  }

}

export class ReplacementDraftDetail {
  id: number;
  draftID: number;
  applicationNumber: number;
  applicationCategory: string;
  applicationCategoryID: string;


  /**Application Properties */
  documents: DocumentDetail[] = [];
  paymentInfos: PaymentInfo[] = [];
  facility: FacilityDetail;
  summary: string;
  replacementReasonID: number;
  /** */

  createdBy: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;

  constructor(draftObject){
    const draftApplication =  JSON.parse(draftObject.applicationJsonData);
    this.draftID  = draftObject.id;
    this.applicationNumber = draftObject.applicationNumber;
    this.applicationCategory = draftObject.applicationCategory;
    this.applicationCategoryID = draftObject.applicationCategoryID;
    this.summary = draftApplication.summary;
    this.replacementReasonID = draftApplication.replacementReasonID;
    this.id  = draftApplication.applicationID;
    this.facility = draftApplication.facility;
    this.createdDate = draftObject.createdDate;
    this.createdBy = draftObject.createdBy;
    this.isActive = draftObject.isActive;
    this.modifiedDate = draftObject.modifiedDate;
    this.rowGuid = draftObject.rowGuid;

    if (draftApplication['documents'].length) {
      for (let rawDoc of draftApplication['documents']) {
        let doc = new DocumentDetail(rawDoc);
        this.documents.push(doc);
      }
    }
    if (draftApplication['paymentInfo']) {
      const paymentInf = draftApplication['paymentInfo'];
      let paymentInfo = new PaymentInfo(paymentInf);
      this.paymentInfos.push(paymentInfo);
    }
  }

}

export class WarehouseAdditionDraftDetail {
  id: number;
  draftID: number;
  applicationNumber: number;
  applicationCategory: string;
  applicationCategoryID: string;
  warehouses: Warehouse[];

  /**Application Properties */
  documents: DocumentDetail[] = [];
  paymentInfos: PaymentInfo[] = [];
  facility: FacilityDetail;
  checkListItems: ChecklistInstance[];
  checkListInstances: ChecklistInstance[];
  checklistComplete: boolean;

  /** */

  createdBy: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
  professionals: Professionals[]= [];
  location: any = {};
  productTypeID: number;
  editableApplicationId: number;

  constructor(draftObject){
    const draftApplication =  JSON.parse(draftObject.applicationJsonData);
    this.draftID  = draftObject.id;
    this.applicationNumber = draftObject.applicationNumber;
    this.applicationCategory = draftObject.applicationCategory;
    this.applicationCategoryID = draftObject.applicationCategoryID;
    this.checklistComplete = draftApplication.checklistComplete;
    this.checkListItems = draftApplication.checkListInstances;
    this.checkListInstances = draftApplication.checkListInstances;
    this.id  = draftApplication.applicationID;
    this.facility = draftApplication.facility;
    this.warehouses = draftApplication.warehouses;
    this.createdDate = draftObject.createdDate;
    this.createdBy = draftObject.createdBy;
    this.isActive = draftObject.isActive;
    this.modifiedDate = draftObject.modifiedDate;
    this.rowGuid = draftObject.rowGuid;
    this.professionals = draftApplication.professionals;
    this.productTypeID = draftApplication.productTypeID;
    this.editableApplicationId = draftApplication.applicationID;

    if (draftApplication['documents'].length) {
      for (let rawDoc of draftApplication['documents']) {
        let doc = new DocumentDetail(rawDoc);
        this.documents.push(doc);
      }
    }
    if (draftApplication['paymentInfos']) {
      for (let paymentInf of draftApplication['paymentInfos']) {
        let paymentInfo = new PaymentInfo(paymentInf);
        this.paymentInfos.push(paymentInfo);
      }
    }
  }

}
export class ReturnDraftDetail {
  id: number;
  draftID: number;
  applicationNumber: number;
  applicationCategory: string;
  applicationCategoryID: string;


  /**Application Properties */
  documents: DocumentDetail[] = [];
  facility: FacilityDetail;
  summary: string;


  createdBy: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;

  constructor(draftObject){
    const draftApplication =  JSON.parse(draftObject.applicationJsonData);
    this.draftID  = draftObject.id;
    this.applicationNumber = draftObject.applicationNumber;
    this.applicationCategory = draftObject.applicationCategory;
    this.applicationCategoryID = draftObject.applicationCategoryID;
    this.summary = draftApplication.summary;
    this.id  = draftApplication.applicationID;
    this.facility = draftApplication.facility;
    this.createdDate = draftObject.createdDate;
    this.createdBy = draftObject.createdBy;
    this.isActive = draftObject.isActive;
    this.modifiedDate = draftObject.modifiedDate;
    this.rowGuid = draftObject.rowGuid;

    if (draftApplication['documents'].length) {
      for (let rawDoc of draftApplication['documents']) {
        let doc = new DocumentDetail(rawDoc);
        this.documents.push(doc);
      }
    }
  }

}

export class ApplicationDetail {
  id: number;
  name: string;
  username: string;
  recieptNumber: string;
  applicationNumber: string;
  position: string;
  applicationTypeID: number;
  applicationType: string;
  applicationTypeCode: string;
  address: Location;
  phoneNo: string;
  facility: FacilityDetail;
  documents: DocumentDetail[] = [];
  paymentInfos: PaymentInfo[] = [];
  inspectionInfos: InspectionInfoDetail[] = [];
  applicationStatusID: number;
  applicationStatus: string;
  applicationStatusCode: string;
  createdBy: number;
  createdDate: string;
  isActive: boolean;
  applicationUserAssignemnts: ApplicationUserAssignment[] = [];
  newApplicationChangeTypes: NewApplicationChangeType[] = [];
  oldApplicationChangeTypes: NewApplicationChangeType[] = [];
  checkListItems: ChecklistInstance[];
  checkListInstances: ChecklistInstance[];
  checklistComplete: boolean;
  applicationCategory: ApplicationCategory;
  previousApplicationID: number;
  previousApplicationNumber: string;
  isLegacyData: boolean;
  flowType: FlowType;
  applicationCategoryID: number;
  flowTypeID: number;
  facilityID: number;
  assignedUser: string;
  assignedUserID: number;
  dueDate: string;
  applicationStatusName: string;
  branchOffice: number;
  branchOfficeID: number;
  editedFields : string;
  changeSummary : string;
  ticketNumber: string;
  applicationInfo: ApplicationInfo;
  isPreviousApplicationLegacyData: boolean;
  specificProductItemObjects : SpecificProductItem[] = [];
  specificProductObjects: SpecificProduct[] = [];
  productTypeID: number;
  productType: string;
  productTypeName: string;
  specificProductIDs: number[];
  specificProductItemIDs: number[];
  specificProducts: string[];
  specificProductItems: string[];
  specificProductCodes: string[];
  specificProductItemCodes: string[];
  mLevelID: number;
  mLevel: string;
  mrLevelID: number;
  mrLevel: string;
  manufacturingRiskLevel: MRLevel;
  manufacuringLevel: MLevel;
  locationID: number;
  location: Location;
  professionals: Professionals[];
  warehouses: Warehouse[];
  isLicenseValid: boolean;
  spiBrandNames;
  etradeTrackingNumber: string;

  constructor(incomingObject: any, professionalTypes) {
    if (incomingObject) {
      this.id = incomingObject['id'];
      if (incomingObject.userDto) {
        this.name = incomingObject.userDto['firstName'] + ' ' + incomingObject.userDto['lastName'];
        this.username = incomingObject.userDto['username'];
        this.position = incomingObject.userDto['profession'];
        this.address = incomingObject.userDto['address'];
        this.phoneNo = incomingObject.userDto['phone'];
        this.applicationTypeID = incomingObject.userDto['applicantTypeID'];
        const type = incomingObject.userDto['applicantType'];
        if(type){
        this.applicationType = type['name'];
        this.applicationTypeCode = type['applicationTypeCode'];
        }

      }
      this.ticketNumber = incomingObject['ticketNumber'];
      this.changeSummary = incomingObject['changeSummary'];
      this.editedFields = incomingObject['editedFields'];
      this.facilityID = incomingObject['facilityID'];
      this.isLegacyData = incomingObject['isLegacyData'];
      this.flowType = incomingObject['flowType'];
      this.branchOffice = incomingObject['branchOffice'];
      this.branchOfficeID = incomingObject['branchOfficeID'];
      this.previousApplicationID = incomingObject['previousApplicationID'];
      this.previousApplicationNumber = incomingObject['previousApplicationNumber'];
      this.isPreviousApplicationLegacyData = incomingObject['isPreviousApplicationLegacyData'];
      this.checklistComplete = incomingObject['checklistComplete'];
      this.applicationNumber = incomingObject['applicationNumber'];
      this.recieptNumber = incomingObject['paymentRecieptNo'];
      this.facility = new FacilityDetail(incomingObject['facility']);
      this.applicationStatusID = incomingObject['applicationStatusID'];
      this.applicationCategory = incomingObject['applicationCategory'];
      this.applicationCategoryID = incomingObject['applicationCategoryID'];
      this.flowTypeID = incomingObject['flowTypeID'];
      this.isLicenseValid = incomingObject['isLicenseValid'];
      this.etradeTrackingNumber = incomingObject['etradeTrackingNumber'];

      const status = incomingObject['applicationStatus'];
      if (status) {
        this.applicationStatus = status['name'];
        this.applicationStatusCode = status['applicationStatusCode'];
      }

      // this.documents = incomingObject['documents'];
      this.createdDate = incomingObject['createdDate'];
      this.createdBy = incomingObject['createdBy'];
      this.recieptNumber = incomingObject['paymentRecieptNo'];
      this.checkListItems = incomingObject['checkListInstances'];
      this.checkListInstances = incomingObject['checkListInstances'];

      if(incomingObject['applicationInfo']){
        this.applicationInfo = new ApplicationInfo(incomingObject['applicationInfo']);
      }

      if (incomingObject['documents']) {
        for (let rawDoc of incomingObject['documents']) {
          let doc = new DocumentDetail(rawDoc);
          this.documents.push(doc);
        }
      }

      if (incomingObject['inspectionInfos']) {
        for (let insInf of incomingObject['inspectionInfos']) {
          let inspectionInfo = new InspectionInfoDetail(insInf);
          this.inspectionInfos.push(inspectionInfo);
        }
      }

      if (incomingObject['paymentInfos']) {
        for (let paymentInf of incomingObject['paymentInfos']) {
          let paymentInfo = new PaymentInfo(paymentInf);
          this.paymentInfos.push(paymentInfo);
        }
      }
      if (incomingObject['applicationUserAssignments']) {
        for (let assignment of incomingObject['applicationUserAssignments']) {
          let assignmentObj = new ApplicationUserAssignment(assignment);
          this.applicationUserAssignemnts.push(assignmentObj);
        }
      }
      if(incomingObject['newApplicationChangeTypes']){
        for(let changeType of incomingObject['newApplicationChangeTypes']){
          let changeTypeObj = new NewApplicationChangeType(changeType);
          this.newApplicationChangeTypes.push(changeTypeObj)
        }
      }

      if(incomingObject['oldApplicationChangeTypes']){
        for(let changeType of incomingObject['oldApplicationChangeTypes']){
          let changeTypeObj = new NewApplicationChangeType(changeType);
          this.oldApplicationChangeTypes.push(changeTypeObj)
        }
      }

      this.productTypeID = incomingObject['productTypeID'];      
      let obj = incomingObject['productType'];
      if (obj) {
        this.productTypeName = this.productType = obj['name'];
      }
      if (incomingObject['facilitySpecificProducts']) {
        this.specificProductIDs = incomingObject['facilitySpecificProducts'].map(sp => sp.specificProductID);
        this.specificProducts = incomingObject['facilitySpecificProducts'].map(sp => sp.specificProduct ?
          sp.specificProduct.name : null);
        this.specificProductCodes = incomingObject['facilitySpecificProducts'].map(sp => sp.specificProduct ?
          sp.specificProduct.specificProductCode : null);
        this.specificProductObjects = incomingObject['facilitySpecificProducts']
          .map(sp => sp.specificProduct)
          .filter(sp => !!sp);
      }
      if (incomingObject['facilitySpecificProductItems']) {
        this.specificProductItemIDs = incomingObject['facilitySpecificProductItems'].map(sp => sp.specificProductItemID);
        this.specificProductItems = incomingObject['facilitySpecificProductItems'].map(sp => sp.specificProductItem ?
          sp.specificProductItem.name : null);
        this.specificProductItemCodes = incomingObject['facilitySpecificProductItems'].map(sp => sp.specificProductItem ?
          sp.specificProductItem.spItemCode : null);
        for(let item of incomingObject['facilitySpecificProductItems']){
          let spi = item.specificProductItem;
          if(spi){
            spi.brandName = item.brandName;
            this.specificProductItemObjects.push(spi);
          }      
        }
      }
      this.mLevelID = incomingObject['manuLevelID'];
      obj = incomingObject['manufacturingLevel'];
      this.mLevel = obj != null ? obj['name'] : null;
      this.mrLevelID = incomingObject['manuRiskLevelID'];
      obj = incomingObject['manufacturingRiskLevel'];
      this.mrLevel = obj != null ? obj['name'] : null;
      this.locationID = incomingObject['locationID'];
      this.location = new Location(incomingObject['location'] || {});
      this.warehouses = incomingObject['warehouses'];
      const p1 = new Professionals(incomingObject['professionals'], professionalTypes);
      this.professionals = [p1];
    }
  }
}

export class NewApplicationChangeType{
  changeTypeID: number;
  dataType: string;
  id: number;
  newApplicationID: number;
  newValue:string;
  newValueObj: any;
  oldApplicationID: number;
  oldValue: string;
  oldValueObj: any;
  changeType: ChangeType

  constructor(incomingObject: any) {
    this.id = incomingObject['id'];
    this.changeTypeID = incomingObject['changeTypeID']
    this.dataType = incomingObject['dataType'];
    this.newApplicationID = incomingObject['newApplicationID'];
    this.newValue = incomingObject['newValue'];
    this.newValueObj = incomingObject['newValueObj'];
    this.oldApplicationID = incomingObject['oldApplicationID'];
    this.oldValue = incomingObject['oldValue'];
    this.oldValueObj = incomingObject['oldValueObj'];
    this.changeType = incomingObject['changeType'];
  }
}

export class FacilityDetail {
  id: number;
  ownerName: string;
  ownerPhoneNumber: string;
  focalPerson: string;
  name: string;
  facilityTypeID: number;
  facilityType: string;
  facilityTypeName: string;
  ownershipTypeID: number;
  ownershipType: string;
  ownershipTypeCode: string;
  facilityCategory: FacilityCategory;
  facilityCategoryName: string;
  facilityCategoryID: number;
  applicationStatusCode: string;
  isLegacyData: boolean;
  applicationID: number;
  tinNumber:string;
  isLicenseCancelled: boolean;
  isLicenseSuspended: boolean;
  organization: Organization;

  constructor(incomingObject: any) {
    if (incomingObject) {
      
      this.applicationID = incomingObject['applicationID'];
      this.applicationStatusCode = incomingObject['applicationStatusCode'];
      this.isLegacyData = incomingObject['isLegacyData'];
      this.facilityCategoryName = incomingObject['facilityCategoryName'];
      this.id = incomingObject['id'];
      this.focalPerson = incomingObject['focalPerson'];      
      this.facilityCategory = incomingObject['facilityCategory'];
      this.facilityCategoryID = incomingObject['facilityCategoryID'];
      this.facilityTypeID = incomingObject['facilityTypeID'];
      let obj = incomingObject['type'];
      if (obj) {
        this.facilityType = obj['name'];
      }
      
      this.ownerName = incomingObject['ownerName'];
      this.ownerPhoneNumber = incomingObject['ownerPhoneNumber'];
      this.ownershipTypeID = incomingObject['organizationTypeID'];
      obj = incomingObject['organizationType'];
      if (obj) {
        this.ownershipType = obj['name'];
        this.ownershipTypeCode = obj['organizationTypeCode'];
      }
      this.name = incomingObject['name'];
      this.organization = incomingObject['organization'];
      if(this.organization){
        this.name = this.name ? this.name : this.organization.name;
      }

      this.tinNumber = incomingObject['tinNumber'];
      this.isLicenseCancelled = incomingObject['isLicenseCancelled'];
      this.isLicenseSuspended = incomingObject['isLicenseSuspended'];
    }
  }
}

export class Location {
  id: number;
  region: any;
  zone: any;
  subCity: any;
  woreda: any;
  regionID: number;
  zoneID: number;
  subCityID: number;
  woredaID: number;
  city: string;
  cityID: number;
  cityModel: City;
  kebele: string;
  houseNo: string;
  phoneNo: string;
  areaName: string;
  gpsLat: number;
  gpsLng: number;

  constructor (incomingObject: any) {
    this.id = incomingObject['id'];
    this.regionID = incomingObject['regionID'];
    this.zoneID = incomingObject['zoneID'];
    this.subCityID = incomingObject['subCityID'];
    this.woredaID = incomingObject['woredaID'];
    this.region = incomingObject['region'];
    this.zone = incomingObject['zone'];
    this.subCity = incomingObject['subCity'];
    this.woreda = incomingObject['woreda'];
    this.city = incomingObject['city'];
    this.cityID = incomingObject['cityID'];
    this.cityModel = incomingObject['cityModel'];
    this.kebele = incomingObject['kebele'];
    this.houseNo = incomingObject['houseNo'];
    this.phoneNo = incomingObject['phoneNo'];
    this.areaName = incomingObject['areaName'];
    this.gpsLat = incomingObject['gpsLat'];
    this.gpsLng = incomingObject['gpsLng'];
  }
}

export class Professionals {
  tlName: string;
  tlEducationLevelID: number;
  tlEducationLevel: string;
  tlQualificationID: number;
  tlQualification: string;
  tlExperience: number;
  tlPhoneNumber: string;
  tlEmail: string;
  tlProfessionalLicenseNumber: string;
  tlExperienceRange: string;
  smName: string;
  smEducationLevelID: number;
  smEducationLevel: string;
  smQualificationID: number;
  smQualification: string;
  smExperience: number;
  smPhoneNumber: string;
  smEmail: string;
  smProfessionalLicenseNumber: string;
  smExperienceRange: string;
  pmName: string;
  pmEducationLevelID: number;
  pmEducationLevel: string;
  pmQualificationID: number;
  pmQualification: string;
  pmExperience: number;
  pmPhoneNumber: string;
  pmEmail: string;
  pmProfessionalLicenseNumber: string;
  pmExperienceRange: string;
  qaName: string;
  qaEducationLevelID: number;
  qaEducationLevel: string;
  qaQualificationID: number;
  qaQualification: string;
  qaExperience: number;
  qaPhoneNumber: string;
  qaEmail: string;
  qaProfessionalLicenseNumber: string;
  qaExperienceRange: string;
  qcName: string;
  qcEducationLevelID: number;
  qcEducationLevel: string;
  qcQualificationID: number;
  qcQualification: string;
  qcExperience: number;
  qcPhoneNumber: string;
  qcEmail: string;
  qcProfessionalLicenseNumber: string;
  qcExperienceRange: string;
  hseName: string;
  hseEducationLevelID: number;
  hseEducationLevel: string;
  hseQualificationID: number;
  hseQualification: string;
  hseExperience: number;
  hsePhoneNumber: string;
  hseEmail: string;
  hseProfessionalLicenseNumber: string;
  hseExperienceRange: string;
  mbName: string;
  mbEducationLevelID: number;
  mbEducationLevel: string;
  mbQualificationID: number;
  mbQualification: string;
  mbExperience: number;
  mbPhoneNumber: string;
  mbEmail: string;
  mbProfessionalLicenseNumber: string;
  mbExperienceRange: string;
  pceName: string;
  pceEducationLevelID: number;
  pceEducationLevel: string;
  pceQualificationID: number;
  pceQualification: string;
  pceExperience: number;
  pcePhoneNumber: string;
  pceEmail: string;
  pceProfessionalLicenseNumber: string;
  pceExperienceRange: string;
  wmName: string;
  wmEducationLevelID: number;
  wmEducationLevel: string;
  wmQualificationID: number;
  wmQualification: string;
  wmExperience: number;
  wmPhoneNumber: string;
  wmEmail: string;
  wmProfessionalLicenseNumber: string;
  wmExperienceRange: string;

  constructor(incomingObject: any, professionalTypes) {
    if (incomingObject) {
      for (let prof of incomingObject) {
        let type = prof['professionalType'];
        if (!type && prof['professionalTypeID'] && professionalTypes) {
          type = professionalTypes.filter(pt => pt.id === prof['professionalTypeID'])[0];
        }

        if (type && type['professionalTypeCode'] === Constants.TECHNICAL_LEADER_CODE) {
          this.tlName =  prof['name'];
          this.tlEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.tlEducationLevel = level != null ? level['name'] : null;
          this.tlQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.tlQualification = level != null ? level['name'] : null;
          this.tlExperience = prof['experience'];
          this.tlProfessionalLicenseNumber = prof['regNumber'];
          this.tlPhoneNumber = prof['phone'];
          this.tlEmail = prof['email'];
          this.tlExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.STORE_MANAGER_CODE) {
          this.smName =  prof['name'];
          this.smEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.smEducationLevel = level != null ? level['name'] : null;
          this.smQualificationID = prof['qualificationID'];
          this.smProfessionalLicenseNumber = prof['regNumber'];
          level = prof['qualification'];
          this.smQualification = level != null ? level['name'] : null;
          this.smExperience = prof['experience'];
          this.smPhoneNumber = prof['phone'];
          this.smEmail = prof['email'];
          this.smExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.PRODUCTION_MANAGER_CODE) {
          this.pmName =  prof['name'];
          this.pmEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.pmEducationLevel = level != null ? level['name'] : null;
          this.pmQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.pmQualification = level != null ? level['name'] : null;
          this.pmExperience = prof['experience'];
          this.pmPhoneNumber = prof['phone'];
          this.pmEmail = prof['email'];
          this.pmProfessionalLicenseNumber = prof['regNumber'];
          this.pmExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.QUALITY_ASSURANCE_CODE) {
          this.qaName =  prof['name'];
          this.qaEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.qaEducationLevel = level != null ? level['name'] : null;
          this.qaQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.qaQualification = level != null ? level['name'] : null;
          this.qaExperience = prof['experience'];
          this.qaPhoneNumber = prof['phone'];
          this.qaEmail = prof['email'];
          this.qaProfessionalLicenseNumber = prof['regNumber'];
          this.qaExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.HYGIENE_AND_SANITATION_EXPERT_CODE) {
          this.hseName =  prof['name'];
          this.hseEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.hseEducationLevel = level != null ? level['name'] : null;
          this.hseQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.hseQualification = level != null ? level['name'] : null;
          this.hseExperience = prof['experience'];
          this.hsePhoneNumber = prof['phone'];
          this.hseEmail = prof['email'];
          this.hseProfessionalLicenseNumber = prof['regNumber'];
          this.hseExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.PHYSICO_CHEMICAL_EXPERT_CODE) {
          this.pceName =  prof['name'];
          this.pceEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.pceEducationLevel = level != null ? level['name'] : null;
          this.pceQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.pceQualification = level != null ? level['name'] : null;
          this.pceExperience = prof['experience'];
          this.pcePhoneNumber = prof['phone'];
          this.pceEmail = prof['email'];
          this.pceProfessionalLicenseNumber = prof['regNumber'];
          this.pceExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.MICROBIOLOGIST_CODE) {
          this.mbName =  prof['name'];
          this.mbEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.mbEducationLevel = level != null ? level['name'] : null;
          this.mbQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.mbQualification = level != null ? level['name'] : null;
          this.mbExperience = prof['experience'];
          this.mbPhoneNumber = prof['phone'];
          this.mbEmail = prof['email'];
          this.mbProfessionalLicenseNumber = prof['regNumber'];
          this.mbExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.Quality_CONTROL_CODE) {
          this.qcName =  prof['name'];
          this.qcEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.qcEducationLevel = level != null ? level['name'] : null;
          this.qcQualificationID = prof['qualificationID'];
          level = prof['qualification'];
          this.qcQualification = level != null ? level['name'] : null;
          this.qcExperience = prof['experience'];
          this.qcPhoneNumber = prof['phone'];
          this.qcEmail = prof['email'];
          this.qcProfessionalLicenseNumber = prof['regNumber'];
          this.qcExperienceRange = prof['experienceYearRange'];
        } else if (type && type['professionalTypeCode'] === Constants.WAREHOUSE_MANAGER_CODE) {
          this.wmName =  prof['name'];
          this.wmEducationLevelID = prof['educationLevelID'];
          let level = prof['educationLevel'];
          this.wmEducationLevel = level != null ? level['name'] : null;
          this.wmQualificationID = prof['qualificationID'];
          this.wmProfessionalLicenseNumber = prof['regNumber'];
          level = prof['qualification'];
          this.wmQualification = level != null ? level['name'] : null;
          this.wmExperience = prof['experience'];
          this.wmPhoneNumber = prof['phone'];
          this.wmEmail = prof['email'];
          this.wmExperienceRange = prof['experienceYearRange'];
        }
      }
    }
  }
}

export class DocumentDetail {
  id: number;
  referenceID: number;
  filePath: string;
  remark: string;
  applicationID: number;
  uploadTime: string;
  inspectionID: number; // for inspection module documents
  documentReference: DocumentRef;

  constructor(incomingObject: any) {
    this.id = incomingObject['id'];
    this.referenceID = incomingObject['referenceID'];
    this.applicationID = incomingObject['applicationID'];
    this.filePath = incomingObject['filePath'];
    this.remark = incomingObject['remark'];
    this.uploadTime = incomingObject['modifiedDate'];

    this.inspectionID = incomingObject['inspectionID'];
    this.documentReference = incomingObject['documentReference'];
    
  }
}

export class PaymentInfoDetail {
  id: number;
  recieptNumber: string;
  documentID: number;
  applicationID: number;
  inspectionID: number; // for inspection module documents

  constructor(incomingObject: any) {
    if (incomingObject) {
      this.recieptNumber = incomingObject['recieptNumber'];
      this.documentID = incomingObject['documentID'];
      this.applicationID = incomingObject['applicationID'];

      this.inspectionID = incomingObject['inspectionID'];
    }
  }
}

export class InspectionInfoDetail {
  id: number;
  fileName: string;
  uploadedTime: string;
  comment: string;
  fileId: number;
  inspectionResult: number;
  applicationID: number;
  inspectionIdentifier: string;
  odkResponseUUID: string;
  odkFormID: string;
  odkFormUploadDate: string;
  remarkObj: string;
  inspectionInfoDocuments: any[];

  constructor(incomingObject: any) {
    let statusLog = incomingObject['statusLog'];
    this.inspectionResult = statusLog.newValue;
    this.comment = statusLog.comment;
    let inspectionDoc = incomingObject['document'];
    this.fileName = inspectionDoc ? inspectionDoc.filePath : null;
    this.uploadedTime = inspectionDoc ? inspectionDoc.modifiedDate : null;
    this.fileId = incomingObject['documentID'];
    this.applicationID = incomingObject['applicationID'];
    this.id = incomingObject['id'];
    this.inspectionIdentifier = incomingObject['inspectionIdentifier'];
    this.odkResponseUUID = incomingObject['odkResponseUUID'];
    this.odkFormID = incomingObject['odkFormID'];
    this.odkFormUploadDate = incomingObject['odkFormUploadDate'];
    this.remarkObj = incomingObject['remarkObj'];
    this.inspectionInfoDocuments = incomingObject['inspectionInfoDocuments'];
  }
}

export class ApplicationUserAssignment {
  id: number;
  applicationID: number;
  userID: number;
  primary: boolean;
  createdDate: Date;

  constructor(incomingObject: any) {
    this.id = incomingObject['id'];
    this.applicationID = incomingObject['applicationID'];
    this.userID = incomingObject['userID'];
    this.primary = incomingObject['primary'];
    this.createdDate = new Date(incomingObject['createdDate']);
  }
}

export class DraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: string;
  applicationJsonData: string;
  draftFacilityData: DraftFacilityData;
  applicationCatagoryID: number;
  applicationCategory: ApplicationCategory;

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;

  }
}

export class RenewalDraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: number;
  applicationJsonData: string;
  applicationCatagoryID: number;
  applicationCategory: string

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;
    this.applicationCatagoryID = 2;
  }
}

export class ReplacementDraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: number;
  applicationJsonData: string;
  applicationCatagoryID: number;
  applicationCategory: string

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;
    this.applicationCatagoryID = 4;
  }
}

export class ReturnDraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: number;
  applicationJsonData: string;
  applicationCatagoryID: number;
  applicationCategory: string

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;
  }
}

export class WarehouseAdditionDraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: number;
  applicationJsonData: string;
  applicationCatagoryID: number;
  applicationCategory: string;

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;
  }
}
export class ChangeDraftApplicationModel {
  id: number;
  applicationNumber: string;
  facilityName: string;
  createdBy: number;
  createdByName: string;
  facilityTypeName: string;
  productTypeName: string;
  createdDate: string;
  modifiedDate: number;
  applicationJsonData: string;
  applicationCatagoryID: number;
  applicationCategory: string

  constructor(applicationDraft: any, savedBy: number) {
    this.applicationJsonData = applicationDraft;
    this.createdBy = savedBy;
  }
}
export class DraftFacilityData {
  id: number;
  facility: DraftFacility;
  applicationStatusID: number;
  applicationNumber: string;
  createdBy: number;
  checkListInstances: [];
  documents: [];
  paymentInfos: [];
  warehouses: Warehouse[];
  ldeType: string;
  productTypeID: number;
  mLevelID: number;
  mrLevelID: number;
  professionals: [];
  facilitySpecificProducts: [];
  facilitySpecificProductItems: [];
  location: {
    regionID: number;
    zoneID: number;
    woredaID: number;
    cityID: number;
    kebele: string;
    houseNo: string;
    phoneNo: string;
    areaName: string
  };
}

export class DraftFacility {
  ownerName: string;
  ownerPhone: string;
  focalPerson: string;
  name: string;
  facilityTypeID: number;
  organizationTypeID: number;
}

export class ChangeType {
  departmentID: number;
  department:   Department;
  name:         string;
  code:         string;
  id:           number;
  isActive:     boolean;
  createdDate:  Date;
  modifiedDate: Date;
  rowGuid:      string;
  isExpanded:   boolean;
  selected:     boolean;
  changeFee:    number;
  withinRegion: boolean;
  changeTypeRefID: number;
  changeTypeRef: ChangeTypeRef;
  constructor(){
    this.changeTypeRef = new ChangeTypeRef();
  }
}

export class ChangeTypeRef{
  id: number;
  name: string;
  description: string;
  shortName: string;
  flowTypeID: number;
  flowType: FlowType;
}

export class AppHistoryLog {
  oldValue: string;
  newValue: string;
  comment: string;
  modifiedByUserID: number;
  applicationID: number;
  oldName: string;
  newName: string;
  oldCode: string;
  newCode: string;
  modifiedByUsername: string;
  modifiedByFullName: string;
  isAssignmentLog: boolean;
  otherAssignees: string;
  modifiedDate: Date;
  reasons: string[];
}
